import React from 'react';
import { Picture } from '@ui';
import { oysterBarPetsCollageImage } from '@images';
import './styles.scss';

const RestWithPets: React.FC = () => (
  <section className='rest-with-pets'>
    <div className='rest-with-pets__container'>
      <div className='rest-with-pets__content'>
        <h2 className='rest-with-pets__title oysterbar-test-title-secondary'>
          <span className='rest-with-pets__title-line'>Приходите</span>
          <span className='rest-with-pets__title-line'>с питомцами</span>
        </h2>

        <ul className='rest-with-pets__list'>
          <li className='rest-with-pets__list-item'>
            Угощаем ваших хвостиков — лакомство на кассе
          </li>
          {/* <li className='rest-with-pets__list-item'>Специальное меню в баре</li> */}
        </ul>

        {/* <div className='rest-with-pets__button'>
          <a
            href='https://storage.delikateska.ru/b/0/b97efc11-1368-467f-9e62-2f16a09cc2d6.png'
            target='_blank'
            rel='noreferrer'
          >
            <Button
              type='btn'
              size='large'
              colour='red'
              rank='primary'
              text='Хвостатое меню'
            />
          </a>
        </div> */}
      </div>

      <div className='rest-with-pets__image'>
        <Picture
          icon={oysterBarPetsCollageImage}
          width='628'
          height='426'
          alt='Pets Collage'
        />
      </div>
    </div>
  </section>
);

export default RestWithPets;
